import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRocket32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRocket32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.75 9.845c1.061-1.061 2.531-1.591 4.133-1.784 1.47-.177 2.9-.05 3.886.103.152.987.28 2.416.103 3.886-.193 1.601-.723 3.071-1.784 4.132-2.447 2.447-5.058 4.139-7.063 5.219-.862.464-1.605.811-2.167 1.055l-3.381-3.381c.243-.562.591-1.305 1.055-2.167 1.08-2.006 2.772-4.617 5.218-7.063m-1.723 14.28a1 1 0 0 1-.036.285l-.719 2.607 5.302-3.418v-1.994a33 33 0 0 1-4.547 2.52m6.546-3.952a31 31 0 0 0 2.93-2.576c2.978-2.979 2.569-7.838 2.197-10.015a1.64 1.64 0 0 0-1.35-1.35c-2.176-.371-7.036-.78-10.014 2.198a31 31 0 0 0-2.576 2.93l-.043-.001H7.79a1 1 0 0 0-.84.458l-3.714 5.76c-.995 1.543.442 3.5 2.212 3.012l2.128-.587 4.356 4.355-.587 2.129c-.487 1.77 1.469 3.207 3.012 2.212l5.76-3.713a1 1 0 0 0 .458-.841v-3.971M10.328 13.36a33 33 0 0 0-2.521 4.547 1 1 0 0 0-.284.036l-2.607.718 3.418-5.301zm7.936.31a1.852 1.852 0 1 0 2.62-2.62 1.852 1.852 0 0 0-2.62 2.62"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRocket32);
